<template>

  <div class="col-md-3">
    <h3>Свойства</h3>
    <div v-if="!selectedAction.id">
      <button class="btn btn-success myBtnStyle fz10 cursor" :disabled="!clickedProductId"
              @click="updateFieldModal(true)">Добавить Свойства
      </button>
      <button class="btn btn-warning myBtnStyle fz10 cursor ml-1" @click="getField()">Изменить</button>
      <button class="btn btn-danger myBtnStyle fz10 cursor ml-1" @click="deleteField()">Удалить</button>
      <button
        v-if="isAdmin && selectedProduct.id !== null"
        type="button"
        class="btn btn-primary myBtnStyle fz10 cursor ml-1 mb-2"
        @click="cloneField(true)"
      >
        клонировать
      </button>
    </div>
    <div v-else>

      <button type="button" class="btn btn-danger myBtnStyle fz10 cursor ml-1 mb-2"
              @click="updateShowField({visible:true})">показать действие
      </button>
    </div>
    <div class="d-flex justify-content-between mb10" v-for="(field, index) in productFields" :key="index">
      <a class="cursor titleHover"
         :class="{highlight:field.id === clickedFieldId, 'bg-danger': field.state === 'I', 'bg-warning': field.state !== 'A' && field.state !== 'I'}"
         @click="fieldClick(field.id)">{{ field.id }} {{ field.title }}</a>
    </div>
    <notValidatedActions
        :notValidatedActions="notValidatedActions"
        :selectedAction="selectedAction"
        @actionClick="actionClick"
    ></notValidatedActions>
    <FieldStore
        :clickedProductId="clickedProductId"
        :selectedProduct="selectedProduct"
        :showFieldModal="showFieldModal"
        :units="units"
        @update="updateFieldModal"
    ></FieldStore>
    <FieldEdit
        :fieldValues="fieldValues"
        :selectedProduct="selectedProduct"
        :fieldEdit="fieldEdit"
        :showFieldEditModal="showFieldEditModal"
        :units="units"
        :languages="languages"
        @update="updateFielEditdModal"
    ></FieldEdit>

    <FieldWatch
        :showFieldWatchModal="showFieldWatchModal"
        :units="units"
        :field="field"
        :fieldValues="fieldValues"
        :selectedProduct="actionProduct"
        @update="updateShowField"
    ></FieldWatch>

    <FieldClone
        :showFieldCloneModal="showFieldCloneModal"
        :selectedProduct="clickedProductId"
        @update="cloneField"
    ></FieldClone>

  </div>
</template>

<script>

import FieldStore from "@/views/allLogic/modals/field/store";
import FieldEdit from "@/views/allLogic/modals/field/edit"
import FieldWatch from "@/views/allLogic/modals/field/watch";
import FieldClone from "@/views/allLogic/modals/field/clone";
import notValidatedActions from "@/views/allLogic/common/notValidatedActions";
import {DELETE, GET} from "@/shared/api";
import {Role} from "@/_helpers/roles";
export default {
  components: {FieldClone, FieldStore, FieldEdit, FieldWatch,notValidatedActions},
  props: {
    units: [],
    selectedProduct: {
      code: null,
      title: null
    },
    languages: [],
  },
  data() {
    return {
      user: null,
      isAdmin: false,
      clickedProductId: null,
      productFields: [],
      clickedFieldId: null,
      fieldValues: [],
      field: {},
      fieldEdit: {},
      showFieldModal: false,
      showFieldWatchModal: false,
      showFieldEditModal: false,
      showFieldCloneModal: false,
      notValidatedActions: [],
      selectedAction: {
        id: null,
      },
      actionProduct: {
        code: null,
        title: null
      },
    }
  },
  watch: {
    selectedProduct: {
      handler: "productChange"
    }
  },
  methods: {

    updateShowField(state) {
      if (typeof state === 'object' && typeof state.visible === 'boolean') {
        this.showFieldWatchModal = state.visible;
        if (this.showFieldWatchModal === true) {
          switch (this.selectedAction.secondShortRoute) {
            case "destroy":
              this.getField(this.selectedAction.request_data.id, false);
              this.actionProduct = this.selectedProduct;
              break;
            default:
              this.field = this.selectedAction.request_data.request;
              if (Array.isArray(this.field.translations)) {
                this.field.translations.forEach((el) => {
                  if (el.locale && el.locale === 'ru') {
                    el.title = this.field.title;
                    el.comment = this.field.comment;
                  }
                });
              }
              if (this.field.translations && this.field.translations.length <= 1) {
                this.field.ru_title = this.field.title;
                this.field.ru_comment = this.field.comment;
              }
              this.fieldValues = this.field.values;
              this.actionProduct = this.selectedProduct;
              // this.getProduct(this.field.product_id);
          }

        }
      }


      if(!this.showFieldWatchModal){
        this.clickedFieldId = null;
        this.fieldValues = [];
        this.field = {};
        this.fieldEdit = {};
      }
    },

    getProduct(id) {
      GET([], "/product/" + id, this, false).then(response => {
        this.actionProduct = response;
      });
    },
    productChange() {

      if (this.selectedProduct.id) {
        this.clickedProductId = this.selectedProduct.id;
        this.getProductFields();
        this.getProductActions();
      } else {
        this.productFields = [];
        this.selectedAction = {
          id: null,
        };
        this.actionProduct = {
          code: null,
          title: null
        };
        this.notValidatedActions = [];
      }


    },
    getProductActions() {
      if (this.selectedProduct.id) {
        GET([], "/product/query/" + this.selectedProduct.id + "?mode=actions", this, false).then(response => {
          let result = response;

          result.forEach((val) => {
            val.request_data = JSON.parse(val.request_data);
            val.route = JSON.parse(val.route);
            if (typeof val.user == 'undefined' || val.user == null) {
              val.user = {
                name: null
              }
            }

            if (typeof val.action === 'undefined' || val.action === null) {
              val.action = {
                action: null,
                user: {
                  name: null
                }
              }
            }
          });
          this.notValidatedActions = result;
        });
      }
    },
    getProductFields() {
      if (this.clickedProductId)
        GET([], "/product/query/" + this.clickedProductId + "?mode=fields", this, false).then(response => {
          this.productFields = response;
        });
    },

    updateCol(event, state) {
      this.$emit(event, state);
    },
    updateFieldModal(state) {
      if (typeof state === 'boolean') {
        if (state) {
          this.fieldValues = [];
          this.field.product_id = this.clickedProductId;
          this.showFieldModal = true;
        } else {
          this.valuesSetDefault();
          this.showFieldModal = false;
        }
      } else if (typeof state == 'object' && state.state) {
        switch (state.state) {
          case "success":
            this.updateFieldModal(false);
            this.clearField();
            this.getProductFields();
            this.getProductActions();
            break;
          case "err":
            this.valuesSetDefault();
            break;
        }
      }

      if(!this.showFieldModal){
        this.clickedFieldId = null;
        this.fieldValues = [];
        this.field = {};
        this.fieldEdit = {};
      }
    },
    updateFielEditdModal(state) {
      if (typeof state === 'boolean') {
        this.showFieldEditModal = state;
      } else if (typeof state == 'object' && state.state) {
        switch (state.state) {
          case "updated":
            this.showFieldEditModal = false;
            this.getProductFields();
            this.getProductActions();
            break;
          case "err":
            break;
        }
      }

      if(!this.showFieldEditModal){
        this.clickedFieldId = null;
        this.fieldValues = [];
        this.field = {};
        this.fieldEdit = {};
      }
    },
    getField(field_id = null, editModal = true) {
      this.fieldValues = [];
      if (field_id === null) {
        field_id = this.clickedFieldId;
      }
      GET([], "/field/query/" + field_id + "?mode=def", this, false).then(response => {
        if (response.inputType === 'range') {
          response.values.forEach((val) => {
            val.value = JSON.parse(val.value);
            delete val.translations;
            this.fieldValues.push(val);
          });
        } else {
          response.values.forEach((val) => {
            delete val.translations;
            this.fieldValues.push(val);
          });
        }
        if (editModal) {
          this.updateFielEditdModal(true);
          this.fieldEdit = response;

        } else {
          this.field = response;
        }

      });
    },
    deleteField() {
      DELETE(this.clickedFieldId, "/field/", this).then(() => {
        this.getProductFields();
        this.getProductActions();
      });
    },
    actionClick(data) {
      this.selectedAction = data.action;
      this.selectedAction.index = data.index;
      this.fieldClick(null)
    },
    fieldClick(field_id) {
      if (field_id !== null) {
        this.selectedAction = {id: null}
      }
      this.clickedFieldId = field_id;
    },
    valuesSetDefault() {
      this.checkboxRows = [{value: ""}];
      this.rangeRows = [{from: "", to: ""}];
      this.field.values = null;
      this.field.isRequired = 0;
      this.field.inputType = 0
      this.prepareFieldValues = [];
    },
    clearField() {
      this.field.ru_title = null;
      this.field.ru_comment = null;
    },
    cloneField(state){
      if (typeof state === 'boolean') {
        this.showFieldCloneModal = state;
      } else if (typeof state == 'object' && state.state) {
        switch (state.state) {
          case "updated":
            this.showFieldCloneModal = false;
            this.getProductFields();
            this.getProductActions();
            break;
          case "err":
            break;
        }
      }
    },
  },
  mounted(){
    this.user = JSON.parse(localStorage.getItem("user"));
    const roles = [...this.user.roles];
    if(this.user.roles){
      if(Array.isArray(roles) && roles.includes(Role.admin)){
        this.isAdmin = true;
      }
    }
  }

}
</script>

<style scoped>

</style>
